/* eslint-disable jsx-a11y/anchor-is-valid */
import '../App.css';
import { useState } from 'react';
import { Button, Input, Radio, Checkbox } from 'antd';
import EstonianFlag from '../flags/ee.svg';
import UKFlag from '../flags/gb.svg';
import RussianFlag from '../flags/ru.svg';
import Swal from 'sweetalert2'
import { CheckCircleFilled } from '@ant-design/icons'
import { DatePicker } from "react-rainbow-components";
import dayjs from 'dayjs';
import 'dayjs/locale/en';
import TextArea from 'antd/es/input/TextArea';
import customParseFormat from 'dayjs/plugin/customParseFormat'
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

const tz = "Europe/Tallinn"

const English = ({ availableDates, csrfTokenState, getCallToForm, getAvailableDates}) => {
  dayjs.locale('en');
  dayjs.extend(customParseFormat)

  const [name, setName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [birthday, setBirthday] = useState(new Date('01-01-2000'));
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedLanguage, setSelectedLanguage] = useState('inglise');
  const [savedReservation, setSavedReservation] = useState(false);
  const [savedReservationNoDate, setSavedReservationNoDate] = useState(false);
  const [emailVerified, setEmailVerified] = useState(null);
  const [description, setDescription] = useState('');
  const [checkBoxChecked, setCheckboxChecked] = useState(false);
  const [loading, setLoading] = useState(false);

  const options = [
    { label: 'estonian', value: 'eesti' },
    /* { label: 'russian', value: 'vene' }, */
    { label: 'english', value: 'inglise' },
    /* { label: 'ukrainian', value: 'ukraina' }, */
  ];

  const onChange = ({ target: { value } }) => {
    setSelectedDate(null);
    setSelectedLanguage(value);
  };

  function onDateChange(date) {
    setBirthday(date);
  }
  
  function selectAvailableDate() {
    const fullName = name + ' ' + lastName;
    if (selectedDate === 'no-date') {
      fetch(`/broneering/broneeri/api/v1/guest/no-select`, {
        method: 'POST',
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "x-csrf-token": csrfTokenState,
          },
          credentials: "include",
          body: `${JSON.stringify({
            name: fullName,
            email,
            phone,
            birthday: dayjs(birthday)?.tz(tz)?.format('DD.MM.YYYY'),
            language: selectedLanguage,
            description
          })}`
      })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false)
        if (!data.error) {
          setSavedReservationNoDate(true)
          setName('');
          setLastName('');
          setEmail('');
          setEmailVerified(null);
          setPhone('');
          setBirthday(null);
          setSelectedLanguage(null)
        }
      })
      .catch((err) => {
        console.error('Error selecting available dates', err)
        setLoading(false)
      })
    } else {

      if (!selectedDate?.id || !selectedLanguage || !selectedDate?.languages.some((language) => language === selectedLanguage)) return null
      fetch(`/broneering/broneeri/api/v1/guest/select/${selectedDate?.id}`, {
        method: 'POST',
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "x-csrf-token": csrfTokenState,
          },
          credentials: "include",
          body: `${JSON.stringify({
            name: fullName,
            email,
            phone,
            birthday: dayjs(birthday)?.tz(tz)?.format('DD.MM.YYYY'),
            language: selectedLanguage,
            description
          })}`
      })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false)
        if (!data.error && data?.message !== 'date already reserved') {
          setSavedReservation(true)
          setName('');
          setLastName('');
          setEmail('');
          setEmailVerified(null);
          setPhone('');
          setBirthday(null);
          setSelectedLanguage(null)
        } else {
          if (data?.status === 'failure' && data?.message === 'date already reserved') {
            setSelectedDate(null)
            Swal.fire({
              title: "Sorry!",
              icon: "info",
              html: `
                This time is no longer available, choose another time.
              `,
              showCloseButton: true,
              focusConfirm: false,
              confirmButtonText: `
                OK
              `,
              confirmButtonAriaLabel: "OK",
            });
            return getCallToForm().then((token) => getAvailableDates(token))
          }
        }
      })
      .catch((err) => {
        console.error('Error selecting available dates', err)
        setLoading(false)
      })
    }
  }

  const selectTheDate = (date) => {
    setSelectedDate(date)
  }

  const getPDF = () => {
    fetch(`/broneering/broneeri/api/v1/guest/pdf/eng`, {
      method: "GET",
      responseType: "blob",
      headers: {
        "x-csrf-token": csrfTokenState,
      },
      credentials: "include",
    })
      .then((res) => res?.arrayBuffer())
      .then(response => {
        if (response) {
          const file = new Blob([response], {type: 'application/pdf'});
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        } else {
          console.error('No response from pdf')
        }
      })
      .catch(error => {
        console.log(error);
      });
  }

  const onCheckboxChange = (e) => {
    setCheckboxChecked(e.target.checked);
  };

  const validateEmail = (email) => {
    if (!email?.length) {
      setEmailVerified(null)
    } else {
      const filterWhiteSpacesEmail = email.replace(/\s+/g, '');
      setEmailVerified(String(filterWhiteSpacesEmail)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      ));
      setEmail(filterWhiteSpacesEmail)
    }
  };

  const getDayOfWeek = (date) => {
    const day = dayjs(date)?.tz(tz)?.day()
    if (day === 0) return 'Su'
    if (day === 1) return 'Mo'
    if (day === 2) return 'Tu'
    if (day === 3) return 'We'
    if (day === 4) return 'Th'
    if (day === 5) return 'Fr'
    if (day === 6) return 'Sa'
    return ''
  }

  if (savedReservation) return (
    <div className="joinOuterContainer">
      <div className="joinInnerContainer">
        <div style={{ fontSize: '27px', textAlign: 'center' }}>You signed up for counseling on {dayjs(selectedDate?.startDate)?.tz(tz)?.format('DD.MM.YYYY HH:mm')?.slice(0, -5)} at {dayjs(selectedDate?.startDate)?.tz(tz)?.format('DD.MM.YYYY HH:mm')?.slice(-5)}.</div>
        <div style={{ textAlign: 'center', fontSize: '18px', marginTop: '10px' }}>Counseling confirmation has been sent to you by email.</div>
        <div style={{ fontSize: '30px', textAlign: 'center', marginTop: '10px' }}><CheckCircleFilled style={{color: 'green', marginRight: '7px'}} /></div>
      </div>
    </div>
  )
  if (savedReservationNoDate) return (
    <div className="joinOuterContainer">
      <div className="joinInnerContainer">
        <div style={{ fontSize: '27px', textAlign: 'center' }}>You signed up for counseling.</div>
        <div style={{ textAlign: 'center', fontSize: '18px', marginTop: '10px' }}>Our counselor will contact you as soon as possible.</div>
        <div style={{ fontSize: '30px', textAlign: 'center', marginTop: '10px' }}><CheckCircleFilled style={{color: 'green', marginRight: '7px'}} /></div>
      </div>
    </div>
  )
  return (
    <div className="App">
      <div id="registration-title-container">
        <div>
            <img onClick={() => window.location.href = '/broneering/broneeri/est'} alt="estonian" style={{ marginRight: '10px', borderRadius: '3px', opacity: 0.4, cursor: 'pointer' }} width={30} src={EstonianFlag} />
            <img onClick={() => window.location.href = '/broneering/broneeri/eng'} alt="english" style={{ marginRight: '10px', borderRadius: '3px', cursor: 'pointer' }} width={30} src={UKFlag} />
            <img onClick={() => window.location.href = '/broneering/broneeri/rus'} alt="russian" style={{ borderRadius: '3px', opacity: 0.4, cursor: 'pointer' }} width={30} src={RussianFlag}/>
        </div>
        <h1>Registration for counselling</h1>
            
        <p>We offer support in coping with everyday concerns.</p>
        <p>Counseling is free of charge. We offer support to anyone who has experienced tensions and difficulties in life and feels the need to talk to someone. Our counselors listen and offer support in finding suitable solutions for the client.</p>
        <p>A mental health specialist will talk to you via video. One consultation lasts up to 60 minutes. We will guide you in technical details so that the meeting will be a smooth success. This service is not psychotherapy or psychiatric help, and it does not replace medical care. However, you can discuss with counselor how to better help yourself and where to turn for professional help.</p>
        <p>Before registering, please read the terms of use of the service. Using the service is considered acceptance of all terms.</p>
        <p>Some time after the counseling you will receive an e-mail asking for feedback. We hope that you take time to give feedback. Feedback is important part of improving the quality of our service.</p>
        <div style={{color: "#304c6d", cursor: 'pointer'}} onClick={() => getPDF()}><u>Read the guide on video counselling for crisis intervention and platforms</u></div>
      </div>

			
      <Input type="hidden" name="_token" value="icIYXsK0pUGahhlBRpYcZ1BfYs8T4pcX1PQYwlKh" />

      <div className="registration-form">
        <div>
          <div className="form-items">
            <label style={{display: 'flex'}}>First name:<div style={{color: 'red', marginLeft: '5px'}}>*</div></label>
            <div style={{ marginTop: '7px', width: '85%' }}>
              <Input onKeyDown={(event) => {
                  if (event.key === 'Enter') document.getElementById('last-name-input')?.focus()
                }} className={checkBoxChecked && !name?.length ? "input-no-length" : ""} value={name} onChange={(e) => setName(e.target.value)} />
            </div>
          </div>
          <div className="form-items">
            <label style={{display: 'flex'}}>Surname:<div style={{color: 'red', marginLeft: '5px'}}>*</div></label>
            <div style={{ marginTop: '7px', width: '85%' }}>
              <Input onKeyDown={(event) => {
                  if (event.key === 'Enter') document.getElementById('email-input')?.focus()
                }} id="last-name-input" className={checkBoxChecked && !lastName?.length ? "input-no-length" : ""} value={lastName} onChange={(e) => setLastName(e.target.value)} />
            </div>
          </div>
          <div className="form-items">
            <label style={{display: 'flex'}}>E-mail:<div style={{color: 'red', marginLeft: '5px'}}>*</div></label>
            <div style={{ marginTop: '7px', width: '85%' }}>
              <Input onKeyDown={(event) => {
                  if (event.key === 'Enter') document.getElementById('number-input')?.focus()
                }} id="email-input" className={checkBoxChecked && !email?.length ? "input-no-length" : ""} value={email} onChange={(e) => validateEmail(e.target.value)} />
            </div>
            <div style={{ fontWeight: 700, color: '#304c6d', width: '85%' }}>
              <small>Please enter the email address you are actively using. We will send an electronic appointment information to this address.</small>
            </div>
          </div>
        
          <div className="form-items">
            <label style={{display: 'flex'}}>Telephone:<div style={{color: 'red', marginLeft: '5px'}}>*</div></label>
            <div style={{ marginTop: '7px', width: '85%' }}>
              <Input 
                type="number"
                className={checkBoxChecked && !phone?.length ? "input-no-length" : ""} 
                onKeyDown={(event) => {
                  if (event.key === '.' || event.key === 'e' || event.key === ' ' || event.code === "Space" ) event.preventDefault()
                  if (event.key === 'Enter') document.getElementById('input-1')?.click()
                }}
                id="number-input"
                onWheel={(e) => e.target.blur()}
                value={phone}
                onChange={(e) => setPhone(e.target.value?.replace(/[^\d]/g, ''))} 
              />
            </div>
          </div>
          <div className="form-items">
            <label style={{display: 'flex'}}>Date of birth:<div style={{color: 'red', marginLeft: '5px'}}>*</div></label>
            <div style={{ marginTop: '7px', width: '85%' }}>
              <DatePicker
                id="datePicker-1"
                value={birthday}
                onChange={onDateChange}
                maxDate={new Date()}
                locale='en'
                label=""
                formatStyle="medium"
              />
            </div>
          </div>
          <div className="form-items">
            <label>Please describe the reason for your appeal in a few sentences:</label>
            <div style={{ marginTop: '7px', width: '85%' }}>
              <TextArea id="reason-input" value={description} maxLength={500} onChange={(e) => setDescription(e.target.value)} />
            </div>
          </div>
        </div>
        <div className="form-items" style={{display: 'flex', marginTop: '7px'}}><div style={{ marginRight: '10px', display: 'flex' }}>Language:<div style={{color: 'red', marginLeft: '5px', marginRight:'10px'}}>*</div> </div> <Radio.Group options={options} onChange={onChange} value={selectedLanguage} /></div>
        <div style={{ maxHeight: '40%', overflow: 'auto' }}>
          <div style={{ height: '100%' }} className="form-items">
            <div className={checkBoxChecked && !selectedDate ? "red-text" : ""} style={{marginBottom: '20px', height: '20px', display: 'flex'}}>Choose a suitable time:<div style={{color: 'red', marginLeft: '5px'}}>*</div></div>
            <div style={{
              height: 'calc(100% - 20px)',
              overflow: 'auto'
            }}>
              <div id={selectedDate === 'no-date' ? "selected": "default"} style={{display: 'flex', marginBottom: '10px', cursor: 'pointer'}} onClick={() => selectTheDate('no-date')}>
                <div style={{ display: 'flex' }}>
                  Couldn't find a suitable time {selectedDate === 'no-date' ? <CheckCircleFilled style={{color: '#1777ff', marginLeft: '5px'}} /> : null}
                </div>
              </div>
              {!availableDates?.filter((date) => date?.languages?.some((language) => language === selectedLanguage) && date?.agentType !== 'experienceAgent')?.length ? <div style={{ fontWeight: 700, fontSize: '20px', color:'black', paddingTop: '10px' }}>No times available</div> : null}
              {availableDates?.filter((date) => date?.languages?.some((language) => language === selectedLanguage) && date?.agentType !== 'experienceAgent')?.sort((a, b) => new Date(a.startDate) - new Date(b.startDate))?.map((date) => {
                return (
                  <div id={selectedDate?.id === date.id ? "selected": "default"} className={date?.client?.name?.length ? "reserved" : ""} style={{display: 'flex', marginBottom: '10px', cursor: 'pointer'}} onClick={() => !date?.client?.name?.length ? selectTheDate(date): null}>
                    <div style={{ display: 'flex' }}>
                    {getDayOfWeek(date?.startDate) + ' '} {dayjs(date?.startDate)?.tz(tz)?.format('DD.MM.YYYY HH:mm')} {selectedDate?.id === date.id ? <CheckCircleFilled style={{color: '#1777ff', marginLeft: '5px'}} /> : null}
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
        <p style={{ display: "flex", justifyContent: 'center' }}><div style={{marginRight: '10px'}}><Checkbox onChange={onCheckboxChange}></Checkbox></div><a style={{color: "#304c6d"}} href="https://sotsiaalkindlustusamet.ee/en/processing-personal-data" target="_blank" rel="noreferrer"><u>I have read and agree to SKA's personal data processing principles</u></a></p>
        <div id="reservation-btn">
          <Button loading={loading} onClick={() => {setLoading(true); selectAvailableDate()}} disabled={!checkBoxChecked || !description?.length || !phone?.length || !/^\d+$/.test(phone) || !name?.length || !lastName?.length || !emailVerified || dayjs(birthday)?.tz(tz)?.format('DD.MM.YYYY')?.length !== 10 || (!selectedDate?.id?.length && selectedDate !== 'no-date') || !selectedLanguage?.length} size="large" type="primary"
          >
            Register
          </Button>
        </div>
      </div>
    </div>
  );
}

export default English;
